/**
 * Modulo que encapsula los formateadores de fechas humanizadas (en texto).
 */

export const humanizers = {
  /**
   * Devuelve la fecha y hora (sin segundos)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @returns {string}
   */
  datetime: (state, formatFn, value) => {
    return formatFn(state, value, 'datetime');
  },
  datetimelong: (state, formatFn, value) => {
    return formatFn(state, value, 'datetimelong');
  },
  date: (state, formatFn, value) => {
    return formatFn(state, value, 'date');
  },
  time: (state, formatFn, value) => {
    return formatFn(state, value, 'time');
  },
  timelong: (state, formatFn, value) => {
    return formatFn(state, value, 'timelong');
  },
};
